// Exporting this way as vue.config.js need the value too
module.exports = {
  dev: {
    primary: '#009688',
    secondary: '#757575',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
    subprimary: '#800000'
  },
  demo: {
    primary: '#009688',
    secondary: '#757575',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
    subprimary: '#800000'
  }
}
